import * as d3 from "d3";

export default class DragGenerator {
    // Public:
    constructor(cParams) {
        this.saveParams(cParams);
        this.setDraggingStatus(false);
    }

    compute() {
        this._func = d3
            .drag()
            .on("start", d => this.dragStarted(d))
            .on("drag", d => this.dragActive(d))
            .on("end", d => this.dragEnded(d));
        return this._func;
    }

    // Private:
    saveParams(cParams) {
        this._elementId = cParams.elementId;
        this._simulationGen = cParams.simulationGen;
    }

    getCircles() {
        const elementId = this._elementId;
        let circles = d3
            .select("#" + elementId)
            .select("svg")
            .selectAll("circle")._groups[0];
        return circles;
    }

    getLabels() {
        const elementId = this._elementId;
        let labels = d3
            .select("#" + elementId)
            .select("svg")
            .selectAll("text")._groups[0];
        return labels;
    }

    dragStarted(d) {
        // this.setDraggedIndex(d);
        this.disableHighlighting();
        if (this.isEventActive()) this._simulationGen.restartAlphaTarget();
        d.fx = d.x;
        d.fy = d.y;
        this.setDraggingStatus(true);
    }

    dragActive(d) {
        // d.fx = this._x;
        // d.fy = this._y;
        d.fx = d3.event.x;
        d.fy = d3.event.y;
    }

    dragEnded(d) {
        this.enableHighlighting();
        if (this.isEventActive()) this._simulationGen.setFinalAlphaTarget();
        d.fx = null;
        d.fy = null;
        this.setDraggingStatus(false);
    }

    isEventActive() {
        if (!d3.event.active) return true;
        else return false;
    }

    enableHighlighting() {
        const elementId = this._elementId;
        let chart = document.getElementById(elementId);
        if (chart.enableHighlighting !== undefined) {
            chart.enableHighlighting();
        }
    }

    disableHighlighting() {
        const elementId = this._elementId;
        let chart = document.getElementById(elementId);
        if (chart.disableHighlighting !== undefined) {
            chart.disableHighlighting();
        }
    }

    setDraggingStatus(status) {
        const elementId = this._elementId;
        const element = document.getElementById(elementId);
        element.isDragOn = status;
    }
    // setDraggedIndex(node) {
    //     const index = node.index;
    //     d3['draggedIndex'] = index;
    // }
}
